var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackRighArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.78,
    height: 12,
    viewBox: "0 0 43.78 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6689",
    "data-name": "Path 6689",
    d: "M275,1040.775l7.669-6-7.669-6h0s-5.673,4.845-36.111,4.845v2.311c30.434,0,36.109,4.842,36.111,4.844Z",
    transform: "translate(-238.89 -1028.775)",
    fill: "#000100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackRighArrow);
export default __webpack_public_path__ + "static/media/black_righ_arrow.daa4a7610ce9600ab791ef0369439775.svg";
export { ForwardRef as ReactComponent };